/**
 * @generated SignedSource<<a7f8fdd7e8a9268a8ad57940b6bb853c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingRecordingStatus = "CALL_ENDED" | "ERROR" | "IN_WAITING_ROOM" | "JOINED_CALL" | "JOIN_REQUEST_DENIED" | "KICKED_OUT" | "LEFT_DUE_TO_INACTIVITY" | "PAUSED" | "READY" | "RECORDING" | "RECORDING_DONE" | "RECORDING_PERMISSION_DENIED" | "SCHEDULED" | "TIME_OUT_EXCEEDED_IN_CALL_NOT_RECORDING" | "TIME_OUT_EXCEEDED_RECORDING_PERMISSION_DENIED" | "TIME_OUT_EXCEEDED_WAITING_ROOM" | "TRANSCRIPTION_DONE" | "UNKNOWN" | "UNRECOVERABLE" | "ZOOM_BOT_IN_WAITING_ROOM" | "ZOOM_HOST_NOT_PRESENT" | "ZOOM_LOCAL_RECORDING_DISABLED" | "ZOOM_LOCAL_RECORDING_GRANT_NOT_SUPPORTED" | "ZOOM_LOCAL_RECORDING_REQUEST_DENIED_BY_HOST" | "ZOOM_LOCAL_RECORDING_REQUEST_DISABLED" | "ZOOM_LOCAL_RECORDING_REQUEST_DISABLED_BY_HOST";
export type RecordingMediaType = "AUDIO" | "VIDEO";
export type MeetingPhaseContext_RecordMeetingMutation$variables = {
  mediaType?: RecordingMediaType | null;
  meetingCallUrl: string;
  noteId: string;
  overrideAutoRecord: boolean;
};
export type MeetingPhaseContext_RecordMeetingMutation$data = {
  readonly recordMeeting: {
    readonly meetingRecording: {
      readonly id: string;
      readonly status: MeetingRecordingStatus;
    };
  } | null;
};
export type MeetingPhaseContext_RecordMeetingMutation = {
  response: MeetingPhaseContext_RecordMeetingMutation$data;
  variables: MeetingPhaseContext_RecordMeetingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mediaType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingCallUrl"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "overrideAutoRecord"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "mediaType",
        "variableName": "mediaType"
      },
      {
        "kind": "Variable",
        "name": "meetingCallUrl",
        "variableName": "meetingCallUrl"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "overrideAutorecord",
        "variableName": "overrideAutoRecord"
      }
    ],
    "concreteType": "RecordMeeting",
    "kind": "LinkedField",
    "name": "recordMeeting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeetingRecording",
        "kind": "LinkedField",
        "name": "meetingRecording",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingPhaseContext_RecordMeetingMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MeetingPhaseContext_RecordMeetingMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "2d3e4db4a65b712cea55104d2d517d4f",
    "id": null,
    "metadata": {},
    "name": "MeetingPhaseContext_RecordMeetingMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingPhaseContext_RecordMeetingMutation(\n  $noteId: ID!\n  $meetingCallUrl: String!\n  $overrideAutoRecord: Boolean!\n  $mediaType: RecordingMediaType\n) {\n  recordMeeting(noteId: $noteId, meetingCallUrl: $meetingCallUrl, overrideAutorecord: $overrideAutoRecord, mediaType: $mediaType) {\n    meetingRecording {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a83643d564eab7eef180b2247a86550f";

export default node;
